import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/carcube-logo.png" 
                alt="CarCube Logo" 
                className="h-8 w-auto"
              />
              <span className="ml-3 text-xl font-bold">CarCube</span>
            </div>
            <p className="text-gray-300 text-sm mb-4">
              Вашата премиум дестинация за автомобили от САЩ и Канада. Намерете качествени 
              автомобили от аукциони с информация в реално време и подробни характеристики.
            </p>

          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase mb-4">
              Бързи връзки
            </h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                  Начало
                </Link>
              </li>
              <li>
                <Link to="/vehicles" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                  Аукциони
                </Link>
              </li>
              <li>
                <Link to="/available" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                  Налични автомобили
                </Link>
              </li>
              <li>
                <Link to="/vehicles?ending_soon=true" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                  Приключващи скоро
                </Link>
              </li>
              <li>
                <Link to="/tracking" className="text-gray-300 hover:text-white text-sm transition-colors duration-200">
                  Проследяване
                </Link>
              </li>
            </ul>
          </div>

          {/* Vehicle Categories */}
          <div>
            <h3 className="text-sm font-semibold text-gray-400 tracking-wider uppercase mb-4">
              Категории
            </h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/vehicles?damage_type=minor" 
                  className="text-gray-300 hover:text-white text-sm transition-colors duration-200"
                >
                  Минимални щети
                </Link>
              </li>
              <li>
                <Link 
                  to="/vehicles?damage_type=hail" 
                  className="text-gray-300 hover:text-white text-sm transition-colors duration-200"
                >
                  Градушка
                </Link>
              </li>
              <li>
                <Link 
                  to="/vehicles?is_buy_now=true" 
                  className="text-gray-300 hover:text-white text-sm transition-colors duration-200"
                >
                  Купи сега
                </Link>
              </li>
              <li>
                <Link 
                  to="/vehicles?sort_by=year&sort_order=desc" 
                  className="text-gray-300 hover:text-white text-sm transition-colors duration-200"
                >
                  Най-нови модели
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-col md:flex-row items-center gap-2 md:gap-4">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} CarCube. Всички права запазени.
              </p>
              <Link 
                to="/privacy-policy" 
                className="text-gray-400 hover:text-white text-sm transition-colors duration-200"
              >
                Политика за поверителност
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
